module.exports = __webpack_public_path__ + "img/Salatpflanzen_setzen.e500272e.jpg";